/**
 * Created by mac on 2017/5/25.
 */

const app = {
  state: {
    appTitle: ""
  },
  mutations: {

  },
  actions: {

  }
}

export default app;



// WEBPACK FOOTER //
// ./src/vuex/modules/app.js